import { get, post } from "@/Utils/axios";
import { IUserForgotPassword, IUserLogin } from "@/Redux/Ducks/userSlice";

export function requestUserLogin(data: { username: string, password: string, languageno: string, clientno: string }): any {
  return post("Authentication/Login", data);
}

export function requestForgotPassword(email: string, clientno: string): any {
  return get("Authentication/ForgotPassword", { params: { email, clientno } });
}

export function requestResetPassword(email: string, token: string, password: string): any {
  return post("Authentication/ResetPassword", { email, token, password });
}

export function requestUserLogout(): any {
  return post("Authentication/Logout");
}

export function requestLoginBasicData(): any {
  return get("Authentication/getBasicData");
}

export function requestUpdatePassword(oldPassword: string, newPassword: string): any {
  return get("Configuration/UpdateUserPassword", { params: { oldPassword, newPassword } });
}

export function requestGetUserSpecificDetail(): any {
  return post("HumanResource/HumanResourceUserSpecificDetail");
}

export function requestRefreshApplication(): any {
  return get("Configuration/RefreshApplication");
}